/**
 * componentRenderers — Maps component types to their React preview renderers
 */
import { PreviewHeader } from './PreviewHeader';
import { PreviewHero } from './PreviewHero';
import { PreviewTrust } from './PreviewTrust';
import { PreviewAuthority } from './PreviewAuthority';
import { PreviewServices } from './PreviewServices';
import { PreviewProofTable } from './PreviewProofTable';
import { PreviewProcess } from './PreviewProcess';
import { PreviewBenefits } from './PreviewBenefits';
import { PreviewTeam } from './PreviewTeam';
import { PreviewGallery } from './PreviewGallery';
import { PreviewTestimonials } from './PreviewTestimonials';
import { PreviewFaq } from './PreviewFaq';
import { PreviewCta } from './PreviewCta';
import { PreviewStickyCta } from './PreviewStickyCta';
import { PreviewFooter } from './PreviewFooter';
import { PreviewCookie } from './PreviewCookie';

export const componentRenderers: Record<string, React.ComponentType<any>> = {
  header: PreviewHeader,
  hero: PreviewHero,
  trust: PreviewTrust,
  authority: PreviewAuthority,
  services: PreviewServices,
  proofTable: PreviewProofTable,
  process: PreviewProcess,
  benefits: PreviewBenefits,
  team: PreviewTeam,
  gallery: PreviewGallery,
  testimonials: PreviewTestimonials,
  faq: PreviewFaq,
  cta: PreviewCta,
  stickyCta: PreviewStickyCta,
  footer: PreviewFooter,
  cookie: PreviewCookie,
};
